/**
 * Custom error for API errors
 */
export class ApiError extends Error {
  response: Response;

  constructor(message: string, response: Response) {
    super(message);
    this.response = response;
  }
}

export async function getApiErrorMessage(
  error: unknown,
  fallback: string
): Promise<string> {
  if (error instanceof ApiError) {
    try {
      const body = (await error.response.json()) as { message?: string };
      return body.message || fallback;
    } catch {
      return fallback;
    }
  }

  if (error instanceof Error && error.message) {
    return error.message;
  }

  return fallback;
}
